(function () {
  var header = document.getElementById('SiteHeader') || document.querySelector('.site-header');
  if (!header) return;

  // Measure the "full" header height once (at or near top)
  var fullHeight = null;

  function measureFullHeight() {
    // If we're near the very top, record the natural (full) height
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (fullHeight == null && y < 10) {
      var r = header.getBoundingClientRect();
      if (r.height > 0) fullHeight = Math.round(r.height);
    }
  }

  function applyState() {
    measureFullHeight();

    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var r = header.getBoundingClientRect();
    var h = Math.round(r.height);

    // If we don't have a baseline yet (e.g., loaded mid-page), infer one
    if (fullHeight == null && h > 0) {
      fullHeight = h; // will refine when user scrolls to top later
    }

    // Consider "sticky/compact" when header is visibly shorter than full height
    var compact = (fullHeight != null) && (h > 0) && (h <= fullHeight - 6); // 6px buffer

    if ((y < 10) || !compact) {
      header.classList.remove('logo-on-sticky');
    } else {
      header.classList.add('logo-on-sticky');
    }
  }

  // Initial
  applyState();

  // rAF-coalesced listeners
  var ticking = false;
  function onScrollResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      applyState();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScrollResize, { passive: true });
  window.addEventListener('resize', onScrollResize);

  // Theme editor section reloads
  document.addEventListener('shopify:section:load', onScrollResize);
  document.addEventListener('shopify:section:unload', onScrollResize);
})();

